import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { Company } from '../models/Company'
import { PATH } from '../app.api'

@Injectable()
export class CompanyService {
	constructor(private http: HttpClient) {}

	public getCompanies(page: number, limit: number): Observable<Array<any>> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.get<any>(`${PATH}/company?page=${page}&limit=${limit}`, {
				headers: options
			})
			.pipe(
				map(result => {
					return result.content
				})
			)
	}
	public getCompanyByName(nameCompany: number): Observable<Array<any>> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.get<any>(`${PATH}/company/details/${nameCompany}`, { headers: options })
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public exportBackup(companyId: string) {
		const options: HttpHeaders = this.setHeader()

		return this.http.post<any>(`${PATH}/company/backup/${companyId}`, {
			headers: options
		})
	}

	public addCompany(company: Company): Observable<any> {
		console.log('COmpany', company)
		const options: HttpHeaders = this.setHeader()

		return this.http.post<any>(`${PATH}/company`, JSON.stringify(company), {
			headers: options
		})
	}

	public editCompany(id: string, company: Company): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http.patch<any>(
			`${PATH}/company/${id}`,
			JSON.stringify(company),
			{ headers: options }
		)
	}

	public checkStatus(companyId: string): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.get<any>(`${PATH}/company/status/${companyId}`, { headers: options })
			.pipe(
				map(result => {
					return result.content.status
				})
			)
	}

	public detailCompany(id: string): Observable<Company> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.get<any>(`${PATH}/company/${id}`, { headers: options })
			.pipe(
				map(res => {
					return res.content
				})
			)
	}

	public getSystemModules(): Observable<
		Array<{ id: number; companyModuleId: number; name: string; active: boolean }>
	> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.get<any>(`${PATH}/company/modules`, { headers: options })
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public removeCompany(id: string): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http.delete<any>(`${PATH}/company/${id}`, { headers: options })
	}

	public getCompanyModuleAssignments(companyId: string) {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.get<any>(`${PATH}/user/assignments/${companyId}`, { headers: options })
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getCompanyQrCodeForRequester(companyId: string): Observable<any> {
		const options: HttpHeaders = this.setHeader()

		return this.http
			.get<any>(`${PATH}/company/qr-code/${companyId}`, { headers: options })
			.pipe(
				map(result => {
					return result.data
				})
			)
	}

	private setHeader(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' }).append(
			'x-source-from',
			'PAINEL'
		)
	}
}
